import { ComponentProps } from "@declarations/props";
import { useThemeStore } from "@stores/theme.store";
import { BottomNavigation } from "@components/general/bottom_navigation";
import { AppBar } from "@components/general/app_bar";
import { useLocation } from "react-router-dom";

export const BaseLayout: ComponentProps = ({ children }) => {
  const location = useLocation();
  const { appBar, bottomNavigation } = useThemeStore((state) => state);
  return (
    <div className="tw-h-screen">
      <div id="page" className="tw-min-h-screen">
        {appBar.show && <AppBar />}
        <div
          className={`page-content tw-relative tw-z-[1] tw-mx-auto tw-min-h-screen ${
            location.pathname !== "/auth/login"
              ? "tw-bg-primary"
              : "tw-bg-primary"
          }`}
        >
          {children}
        </div>
        {bottomNavigation !== "hidden" && (
          <BottomNavigation type={bottomNavigation} />
        )}
      </div>
    </div>
  );
};
